import { IActions, IState } from "./interfaces";
import { ILanguageTranslations } from "./interfaces/languages";
import React from "react";
import { Results } from "./types";
import { useReactHookz } from "./state";
import styles from "./styles";

interface Props {
  results: Results;
}

const ResultsDisplay: React.FC<Props> = ({ results }) => {
  if (results.error) return <p>{results.error}</p>;

  const hasResults = Object.keys(results).some((key) => key !== "error");

  const [state]: [IState, IActions] = useReactHookz();
  const t = state.translations as ILanguageTranslations;

  return (
    hasResults && (
      <div>
        <h4 style={styles.title}>{t.resultsHeader}</h4>
        <section style={styles.results}>
          <div style={styles.resultsGridStyle}>
            {Object.entries(results).map(
              ([key, value]) =>
                key !== "error" && (
                  <div key={key} style={styles.item}>
                    <div style={styles.gridLabel}>
                      {t.resultLabels?.[key] || key}
                    </div>
                    <div style={styles.line} />
                    <div style={styles.value}>{value}</div>
                  </div>
                )
            )}
          </div>
        </section>
      </div>
    )
  );
};

export default ResultsDisplay;
